/** @param {Record<string, unknown>} ctx */
export function clearExchangeVersions(ctx) {
  const { exchangeIds, setActiveQueryVersionByExchangeId, setActiveAnswerVersionByExchangeId } = ctx
  setActiveQueryVersionByExchangeId((prev) => {
    const next = { ...prev }
    for (const id of exchangeIds) delete next[id]
    return next
  })
  setActiveAnswerVersionByExchangeId((prev) => {
    const next = { ...prev }
    for (const id of exchangeIds) delete next[id]
    return next
  })
}
